var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.7096H5.83335C2.79169 17.7096 1.04169 15.9596 1.04169 12.918V7.08464C1.04169 4.04297 2.79169 2.29297 5.83335 2.29297H14.1667C17.2084 2.29297 18.9584 4.04297 18.9584 7.08464V12.918C18.9584 15.9596 17.2084 17.7096 14.1667 17.7096ZM5.83335 3.54297C3.45002 3.54297 2.29169 4.7013 2.29169 7.08464V12.918C2.29169 15.3013 3.45002 16.4596 5.83335 16.4596H14.1667C16.55 16.4596 17.7084 15.3013 17.7084 12.918V7.08464C17.7084 4.7013 16.55 3.54297 14.1667 3.54297H5.83335Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 10.7263C9.29984 10.7263 8.59151 10.5096 8.04984 10.0679L5.4415 7.98461C5.17483 7.76795 5.12484 7.37628 5.34151 7.10961C5.55817 6.84294 5.94984 6.79295 6.21651 7.00961L8.82483 9.09295C9.45817 9.60128 10.5332 9.60128 11.1665 9.09295L13.7748 7.00961C14.0415 6.79295 14.4415 6.83461 14.6498 7.10961C14.8665 7.37628 14.8248 7.77628 14.5498 7.98461L11.9415 10.0679C11.4082 10.5096 10.6998 10.7263 9.99984 10.7263Z",
    fill: "#026C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.866c76ffbdbc3848393a8620bc7381a3.svg";
export { ForwardRef as ReactComponent };